import { SVGProps } from "react";

export default function SlideNextIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 28, width = 28, fill = "#6F7782", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M14 2C16.3734 2 18.6934 2.70379 20.6668 4.02236C22.6402 5.34094 24.1783 7.21508 25.0865 9.4078C25.9948 11.6005 26.2324 14.0133 25.7694 16.3411C25.3064 18.6689 24.1635 20.807 22.4853 22.4853C20.807 24.1635 18.6689 25.3064 16.3411 25.7694C14.0133 26.2324 11.6005 25.9948 9.4078 25.0865C7.21508 24.1783 5.34094 22.6402 4.02236 20.6668C2.70379 18.6934 2 16.3734 2 14C2.00349 10.8185 3.26889 7.76825 5.51857 5.51857C7.76825 3.26889 10.8185 2.00349 14 2ZM10.6914 19.8543C10.5475 20.03 10.4785 20.2553 10.4994 20.4814C10.5202 20.7076 10.6292 20.9164 10.8029 21.0629C10.9782 21.2077 11.2037 21.2772 11.4301 21.2564C11.6566 21.2355 11.8655 21.1259 12.0114 20.9514L17.3086 14.5486C17.4373 14.3948 17.5078 14.2006 17.5078 14C17.5078 13.7994 17.4373 13.6052 17.3086 13.4514L12.0114 7.04857C11.8659 6.87353 11.6569 6.76345 11.4302 6.74255C11.2036 6.72166 10.9779 6.79165 10.8029 6.93714C10.6278 7.08263 10.5177 7.2917 10.4968 7.51835C10.4759 7.745 10.5459 7.97067 10.6914 8.14571L15.5343 14L10.6914 19.8543Z"
        fill={fill}
      />
    </svg>
  );
}
